
/**
 * Keeps Swym's Back In Stock "Notify me" widget in sync with this theme's
 * AJAX variant switching (variant-picker.js), which replaces the buy-buttons
 * DOM on every variant change and discards whatever Swym injected there.
 * Swym's own SBiSA script has no hook to re-render for a swapped-in variant,
 * so once a real variant swap lands on a sold-out variant, force a real page
 * load (the same thing a hard refresh does) instead of leaving the AJAX-swapped
 * DOM in place.
 */
document.addEventListener('on:variant:change', function (evt) {
  var picker = evt.target;
  if (picker.closest('.js-quickbuy') || picker.closest('.cc-featured-product')) return;

  var section = picker.closest('.shopify-section') || document;
  var addBtn = section.querySelector('[name="add"]');
  if (!addBtn || !addBtn.disabled) return;

  var idInput = section.querySelector('input[name="id"]');
  if (!idInput || !idInput.value) return;

  var url = new URL(window.location.href);
  url.searchParams.set('variant', idInput.value);
  window.location.href = url.toString();
});
